import React from 'react'
import "../index.scss";
import { currencySignAndNegativeValueAdjust } from '../../../../utils/commonFunctions';

type AppProps={
    data:number;
    sideHeading:string;
    currencySign:string | undefined;
}

const DetailedBalanceSheetReportFooter = ({data,currencySign,sideHeading}:AppProps) => {
  return (
    <div className="report-footer">
    <div style={{width:"75%",paddingLeft:"1%"}}>{sideHeading}</div>
    <div style={{width:"25%",paddingLeft:"4%"}}> {currencySignAndNegativeValueAdjust(currencySign,data?data?.toFixed(2)?.toString():"0")}</div>
    </div>
  )
}

export default DetailedBalanceSheetReportFooter